/**
 * Copy text to clipboard with a Safari/iOS-safe fallback.
 *
 * navigator.clipboard.writeText is unreliable in two cases we hit on
 * meetup.finally.plus:
 *   1. Older mobile Safari (pre-iOS 13.4) — no Clipboard API at all.
 *   2. Any browser when the call is not inside a direct user gesture
 *      handler (we are inside one here, but it's worth being robust).
 *
 * The fallback path constructs a hidden textarea, selects it, and runs
 * document.execCommand("copy"). Deprecated but still works in every
 * browser today.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // fall through to legacy path
    }
  }

  if (typeof document === "undefined") return false;

  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.position = "fixed";
  ta.style.top = "0";
  ta.style.left = "0";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.select();

  let ok = false;
  try {
    ok = document.execCommand("copy");
  } catch {
    ok = false;
  }
  document.body.removeChild(ta);
  return ok;
}
